import FormElementInputChips from '@/components/FormElementInputChips/FormElementInputChips';

export default FormElementInputChips;
